export default __webpack_public_path__ + "locales/lv/DeleteDialog.json?hash=aee10b1e8ab5311d5e9c1c203e9744cf";